import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload } from './utils'

//const API_ROOT = 'http://localhost/api'

export const getEFormDocumentPage = (projectVersionId, groupId, requestId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/eform/page/${groupId}/${requestId}`
  return doGet(url)
}

export const saveEFormDocument = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/eform/upload`
  return doPost(url, request)
}

export const downloadFileByPath = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const deleteEFormDocumentById = (id) => {
  const url = `${API_ROOT}/progress/eform/delete/${id}`
  return doDelete(url)
}

// export const sendFileToEForm = (id, request) => {
//   const url = `${API_ROOT}/progress/${id}/eform/send-file-to-infoma`
//   return doPost(url, request)
// }

// export const getEFormSystemDocument = (projectVersionId) => {
//   const url = `${API_ROOT}/progress/${projectVersionId}/infoma-doc`
//   return doGet(url)
// }
